<div class="bg-coral-medium">
        <section id="inner-banner">
            <article class="container">
                <div class="row">
                    <div class="modalAction" *ngIf="pageLoad"></div>
                    <div class="col-md-12 col-sm-12 col-xs-12 padB10 wow fadeInLeft">
                        <div class="white-color" *ngIf="headerData">
                           <MARQUEE *ngIf="windowFlag" >{{getWindowEndDate}}
                            </MARQUEE>
                            <MARQUEE *ngIf="!windowFlag" >{{getFinanciarMessage}}
                            </MARQUEE>
                            <!-- <p class="para white-color" name="topNoteTaxForm">Dear Shareholder, Kindly note that the portal shall be available for the shareholder to submit the tax forms or various tax documents between June 1, 2020 to June 15, 2020. No tax forms or tax documents will be considered after June 15, 2020. We request you to kindly take note of the same accordingly.
                            </p> -->
                            <!-- Interim Dividend of Financial Year 2020-2021  -->
                            <div class="row" >
                                    <div class="clearfix"></div>
                                    <div class=" panel-year col-md-2">
                                        <label>Financial Year</label>
                                        <div class="dropdown">
                                            <button id="btnYear" type="button" class="btn-select" data-toggle="dropdown">{{getSelYear()}}</button>
                                            <ul class="dropdown-menu dropdown-menu-select" style="display: none;">
                                                <!-- <li *ngFor="let year of headerData?.financialYear;let i = index">
                                                    <label class="dropdown-radio">
                                                        <input id="year" type="radio" value="{{year.cycle_name}}" (change)="selYear = year['cycle_name'];changeCycleOnSelect(year)" name="Financial">
                                                        <i>{{year['cycle_name']}}</i>
                                                    </label>
                                                </li> -->
                                                <li *ngFor="let year of financialYearArr;let i = index">
                                                    <label class="dropdown-radio">
                                                        <input id="year" type="radio" value="year" (change)="selYear=year;getAssessmentYear(year)" name="Financial">
                                                        <i>{{year}}</i>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class=" panel-year col-md-4" style="margin-right: -40px;margin-left: -40px;">
                                        <label>Dividend Cycle</label>
                                        <div class="dropdown">
                                            <button id="btnCycle" type="button" class="btn-select" data-toggle="dropdown">{{getCycleName()}}</button>
                                            <ul class="dropdown-menu dropdown-menu-select" style="display: none;">
                                                <li *ngFor="let year of headerData?.cycle_details;let i = index">
                                                    <span *ngIf="year['cycle_name']==selYear">
                                                    <label  class="dropdown-radio">
                                                        <input id="cycleName" type="radio" value="{{year.cycle_description}}" (change)="cycleName=year['cycle_description'];changeCycleOnSelect(year);" name="cycleName">
                                                        <i>{{year['cycle_description']}}</i>
                                                    </label>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class=" panel-year col-md-2">
                                        <label>Assessment Year</label>
                                        <div class="txt-value">{{assessmentYear}}</div>
                                    </div>
                                    <!-- <div class="panel-year col-md-2">
                                            <label>Tax Residency</label>
                                            <div class="txt-value">India</div>
                                        </div> -->
                            </div>
    
                            <!-- <div class="row"  *ngIf="headerData?.isResident == 'N'">
                                <div class="clearfix"></div>
                                <div class=" panel-year col-md-2">
                                    <label>Financial Year</label>
                                    <div class="dropdown">
                                        <button id="btnYear" type="button" class="btn-select" data-toggle="dropdown">{{getSelYear()}}</button>
                                        <ul class="dropdown-menu dropdown-menu-select" style="display: none;">
                                            <li *ngFor="let year of headerData?.financialYear;let i = index">
                                                <label class="dropdown-radio">
                                                    <input id="year" type="radio" value="{{year.name}}" (change)="selYear = year['name'];changeCycleOnSelect(year)" name="Financial">
                                                    <i>{{year.name}}</i>
                                                </label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class=" panel-year col-md-2">
                                    <label>Assessment Year</label>
                                    <div class="txt-value">{{headerData?.assessmentYear}}</div>
                                </div>
                                <div class="panel-year col-md-3">
                                    <label>Tax Residential Status In FY 2020-21</label>
                                    <div class="txt-value">Non-Resident</div>
                                </div>
                                <div class="panel-year col-md-2">
                                        <label>Tax Residency</label>
                                        <div class="txt-value">{{headerData?.countryofTaxResidence}}</div>
                                </div>
                                <div class="panel-year col-md-3">
                                        <label> Shareholding Percentage</label>
                                        <div class="txt-value">{{headerData?.shareHoldingPercent}}</div>
                                </div>
    
                                
                                
                            </div> -->
    
    
                        </div>
                    </div>
                </div>
            </article>
        </section>
    </div>
    <section class="panel-things-do">
        <div class="container">
            <div *ngIf="bln206ab && windowFlag" class ="cssmarquee display-none">
                <div *ngIf="getHeaderData['isResident']=='R'" >{{get206abResidentMessage}}</div>
                <div *ngIf="getHeaderData['isResident']=='N'" >{{getNonResident206abMessage}}</div>
            </div>
            <h2 class="title-things">Things to do</h2>
            <br>
            <div class="row row-eq-height">
                <div *ngIf="windowFlag" class="col-md-4 col-12">
                    <div class="things-sub-section">
                        <h3 class="title-sub-section">Upload tax forms</h3>
                        <ul class="ref-links">
                            <li *ngFor="let form of formData">
                                <a href="javascript:void(0);" (click)="showForm(form.name)">{{form.name}}</a> 
                            </li>
                        </ul>
                    </div>
                </div>




                <div  *ngIf="!windowFlag" class="col-md-4 col-12">
                    <div class="things-sub-section">
                        <h3 class="title-sub-section">Download TDS certificate</h3>
                        <ul *ngIf="!(maskTDSData== undefined || maskTDSData== null || maskTDSData== '')" class="ref-links">
                            <li *ngFor="let TDS of maskTDSData">
                                <a href="javascript:void(0);" (click)="fnDownloadTDSDoc(TDS.documentAzureName)">{{TDS.documentName}}</a>
                            </li>
                            <!-- <li>
                                <a href="javascript:void(0);">Dividend 2020</a>
                            </li>
                            <li>
                                <a href="javascript:void(0);">Dividend 2019</a>
                            </li>
                            <li>
                                <a href="javascript:void(0);">Dividend 2020</a>
                            </li> -->
                        </ul>
                        <div *ngIf="maskTDSData== undefined || maskTDSData== null || maskTDSData== ''" class="address">
                            TDS Documents are not available
                        </div>
                    </div>
                </div>
                



                <div class="col-md-4 col-12">
                    <div class="things-sub-section">
                        <h3 class="title-sub-section">For queries</h3>
                        <div class="address">
                            Please contact
                            <br> dividend.tax&#64;infosys.com
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="!windowFlag" class="col-md-8 col-12" >
                
                <p > <br> NOTE: The password to open the TDS certificate is PAN in uppercase (Capital letters).</p>
            </div>
        </div>
    </section>
    <div id="tabView">
        <div  class="container">
            <div *ngIf="formName!=''" class="inner-cont">
                <div class="tabs-sec">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" aria-controls="my-data" role="tab" data-toggle="tab" aria-expanded="true" (click)="showForm(formName)" href="#formName">{{formName}}</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" aria-controls="my-data" role="tab" data-toggle="tab" aria-expanded="true" href="#otherform">Any other declaration</a>
                        </li>
                    </ul>
                </div>
                <div *ngIf="formName=='Form 10F'">
                    <br>
                    <p class="para" style="font-size:18px">Non Resident Shareholders who wish to avail benefit of Tax treaty have to obtain Form 10F electronically from Income Tax portal <a href="https://www.incometax.gov.in/iec/foportal" target ="_blank">(https://www.incometax.gov.in/iec/foportal).</a></p>
                </div>
                <!-- Tab panes -->
                <div class="tab-content">
                    <div class="tab-pane active" id="formName">
                        <div *ngIf="formName=='Form 15G' || formName == 'Form 15H'">
                            <app-taxforms [formName]="formName" [cycleFlag]="cycleFlag" [windowFlag]="windowFlag" [cycleName]="cycleName" [selYear]="selYear" (scrollOnLoad)="scrollOnLoad($event)" (pageName)="successform($event)"></app-taxforms>
                        </div>
                        <div *ngIf="formName!='Form 15G' && formName != 'Form 15H'">
                           <app-taxform-non-residential [formName]="formName" [cycleFlag]="cycleFlag" [windowFlag]="windowFlag" [cycleName]="cycleName" [selYear]="selYear" (scrollOnLoad)="scrollOnLoad($event)" (pageName)="successform($event)" ></app-taxform-non-residential>
                        </div>
                    
                    </div>
                    
                    <div class="tab-pane" id="otherform">
                        <app-taxform-non-residential [formName]="'otherform'" [cycleFlag]="cycleFlag" [windowFlag]="windowFlag" [cycleName]="cycleName" [selYear]="selYear" (scrollOnLoad)="scrollOnLoad($event)" (pageName)="successform($event)"></app-taxform-non-residential>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
    <!-- <hr class="horz-divider"> -->
    <footer>
            <div class="container">
                <div class="row clsFooter">
                       
                    <div class="col-md-6 col-12">Copyright © 2020, Infosys</div>
                    <div class="col-md-6 col-12 text-right"><a href="javascript:void(0);" (click)="gotoPage()">Privacy Statement</a></div>
                    <div class="col-sm-12 col-md-12" style="text-align: center;">
                            For best experience, use edge, chromium, google chrome, firefox, android or iOS
                        </div>
                </div>
            </div>
    </footer>
    
    <div *ngIf="this.blnSuccessPopup" class="modal fade show" id="modal-success" style="display: block; padding-right: 17px;background: rgba(0,0,0,0.5);" aria-modal="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                  
                    <div class="modal-body pad0 text-center marT30">
                         <button type="button" class="close" data-dismiss="modal" (click)="closeModalPopup()">&times;
                        </button>
                        <div class="clearfix pt-4">                           
                            <img src="assets/images/icon-success.png" alt="success"></div>                 
                       
                        <p class="modal-message" *ngIf="blnTextMsgResidential">Thanks for providing the details the same is under processing. We shall verify the details and Unique Indentification Number shall be generated if it meets all the conditions stipulated therein. Once the Unique Indentification Number is generated, we shall communicate the same</p>
                        <p class="modal-message" *ngIf="blnTextMsgNonResidential">Thanks for providing the details the same is under processing.</p>                        
                        <hr class="horz-divider">
                        <div class="text-center"><button class="btn-primary" data-dismiss="modal" type="button" (click)="closeModalPopup()">Ok</button></div>
                    </div>
                </div>
            </div>
        </div>
